// Media and Coverage — where Antara has been written about.
//
// One entry per piece, grouped by the evening it covered, newest evening first.
// Adding a clipping is one entry here plus, for a print piece, one image in
// /public/img/media. Nothing else needs touching, and a second evening becomes a
// second group without a redesign.
//
// EVERY PIECE CARRIES A LINK, and each is named for what it actually opens:
//   url      — a real article. The headline links out.
//   epaper   — the paper's edition online, where the piece never got a web
//              article. It opens a page viewer, not a story, and its path is
//              date-based and will not survive the archive rolling over, so the
//              cutting stays the durable record and this sits beside it.
//   neither  — the line says where the piece ran, with the page number where we
//              could read it off the edition, and links to the paper itself.
// A print piece is never given an "article" link it does not have.
//
// Headlines stay in the language they were published in.

export const MEDIA_COVERAGE = [
  {
    id: "bhaav-sangam-delhi-2026-10-23",
    title: "Bhaav Sangam, Bhajan Jamming in Delhi",
    context: "The Grand, Vasant Kunj, 23 October 2026",
    pieces: [
      {
        publication: "Virat Vaibhav",
        date: "",
        headline: "अंतरा ने लोगों को एक साथ गाने, आत्मचिंतन करने और स्वयं से दोबारा जुड़ने का अवसर दिया",
        language: "hi",
        excerpt:
          "काशी विद अंशु की संस्थापक अंशु गोयल द्वारा क्यूरेट किए गए भजन-जैमिंग और स्टोरीटेलिंग एक्सपीरिएंस ने नई दिल्ली में लोगों को एक साथ आने का अवसर दिया।",
        clipping: "/img/media/virat-vaibhav-2026-10.jpg", clipW: 1143, clipH: 499,
        wide: true,
      },
      {
        publication: "Veer Arjun",
        date: "",
        headline: "अंतरा ने भजन-जैमिंग के जरिए 750 से अधिक लोगों को जोड़ा",
        language: "hi",
        excerpt:
          "काशी विद अंशु की संस्थापक अंशु गोयल द्वारा क्यूरेट किए गए भजन-जैमिंग और स्टोरीटेलिंग अनुभव अंतरा का आयोजन नई दिल्ली में किया गया। कार्यक्रम में 750 से अधिक लोगों ने भाग लिया।",
        clipping: "/img/media/veer-arjun-2026-10.jpg", clipW: 432, clipH: 490,
      },
      {
        publication: "Navodaya Times",
        date: "2026-10-27",
        headline: "ANTARA ने लोगों को एक साथ गाने, आत्मचिंतन करने और स्वयं से दोबारा जुड़ने का दिया अवसर",
        language: "hi",
        url: "https://www.navodayatimes.in/news/delhi/antara-event-brings-people-together-through-singing-self-reflection/302906/",
        excerpt:
          "ANTARA ने लोगों को एक साथ गाने, आत्मचिंतन करने और खुद से दोबारा जुड़ने का अवसर दिया। इस पहल के जरिए सामूहिक संगीत और व्यक्तिगत जुड़ाव को बढ़ावा मिला।",
      },
      {
        // One press release, run word for word by several news sites around
        // the same day. Shown once, with every site that carried it, rather than as six
        // identical cards; and kept out of the home page masthead strip, which
        // is for papers that wrote their own piece.
        kind: "release",
        publication: "Press release",
        date: "2026-10-27",
        headline: "ANTARA Creates a Space to Sing Together, Look Within and Reconnect With Yourself",
        language: "en",
        excerpt:
          "\u201CWe spend so much of our lives looking outside ourselves \u2013 for happiness, validation and answers. ANTARA is an invitation to come as you are, sing without inhibition and allow yourself to go a little deeper within.\u201D",
        carriedBy: [
          { publication: "India Education Diary", url: "https://indiaeducationdiary.in/antara-creates-a-space-to-sing-together-look-within-and-reconnect-with-yourself/" },
          { publication: "Passionate In Marketing", url: "https://www.passionateinmarketing.com/antara-creates-a-space-to-sing-together-look-within-and-reconnect-with-yourself/" },
          { publication: "FM Live", url: "https://www.fmlive.in/antara-creates-a-space-to-sing-together-look-within-and-reconnect-with-yourself/" },
          { publication: "Business News Week", url: "https://businessnewsweek.in/entertainment/antara-creates-a-space-to-sing-together-look-within-and-reconnect-with-yourself/" },
          { publication: "National Biz News", url: "https://nationalbiznews.com/entertainment/antara-creates-a-space-to-sing-together-look-within-and-reconnect-with-yourself" },
          { publication: "The IndustrialPunch", url: "https://www.industrialpunch.com/antara-bhajan-jamming-anshu-goyal/" },
          { publication: "Orissa Diary", url: "https://orissadiary.com/antara-creates-a-space-to-sing-together-look-within-and-reconnect-with-yourself/" },
        ],
        wide: true,
      },
    ],
  },
  {
    id: "antara-delhi-2026-08-30",
    title: "Antara, Bhajan Jamming in Delhi",
    context: "Shah Auditorium, 30 August 2026",
    pieces: [
      {
        publication: "Press Trust of India",
        date: "2026-08-31",
        headline: "Manoj Tiwari joins over 1,000 at bhajan-jamming session in Delhi",
        language: "en",
        url: "https://www.ptinews.com/detail/national/manoj-tiwari-joins-over-1-000-at-bhajan-jamming-session-in-delhi/4020732",
        // ptinews.com refuses automated requests, so this is the same wire copy
        // as carried and PTI-bylined by The Print, which is the text PTI filed.
        excerpt:
          "More than 1,000 people came together at Shah Auditorium for a bhajan-jamming session that sought to move beyond the traditional performer-audience format and encourage collective singing, participation and introspection.",
      },
      {
        publication: "The Print",
        date: "2026-08-31",
        headline: "Manoj Tiwari joins over 1,000 at bhajan-jamming session in Delhi",
        language: "en",
        url: "https://theprint.in/india/manoj-tiwari-joins-over-1000-at-bhajan-jamming-session-in-delhi/3029646/",
        excerpt:
          "Curated by Anshu Goyal, founder of Kashi with Anshu, the event titled ANTARA blended traditional devotional compositions with live band instrumentation, including deep basslines, electric guitars and percussion.",
      },
      {
        publication: "The Print Hindi",
        date: "2026-08-31",
        headline: "दिल्ली में भजन-जैमिंग सत्र में मनोज तिवारी सहित 1,000 से अधिक लोग हुए शामिल",
        language: "hi",
        url: "https://hindi.theprint.in/india/over-1000-people-including-manoj-tiwari-attend-bhajan-jamming-session-in-delhi/1021555/",
        excerpt:
          "शाह सभागार में आयोजित एक भजन-जैमिंग सत्र में 1,000 से अधिक लोग एकत्र हुए। इस कार्यक्रम का उद्देश्य पारंपरिक कलाकार-दर्शक प्रारूप से इतर लोगों को सामूहिक गायन, भागीदारी और आत्मनिरीक्षण के लिए प्रेरित करना था।",
      },
      {
        publication: "Dainik Jagran",
        date: "2026-08-31",
        // The coverage sheet read "भजन के सुर में"; the cutting itself prints
        // "भजनों के सुर में". The paper's own words win.
        headline: "न दर्शक, न कलाकार…भजनों के सुर में हर कोई बना सहभागी",
        language: "hi",
        epaper:
          "https://epaper.jagran.com/mepaper/image-31-Aug-2026-edition-delhi-city-page_16-16264-111-4.html",
        clipping: "/img/media/dainik-jagran-2026-08-31.jpg", clipW: 1600, clipH: 766,
        wide: true,
      },
      {
        publication: "The Morning Standard",
        date: "2026-08-31",
        // A photo feature rather than a written piece. The sheet read "The
        // Bhajan Beats"; the page prints "Bhajan Beats". No online edition and
        // no public e-paper link, so the entry states where it ran instead:
        // page 2, read off the edition, where the caption matches the cutting.
        headline: "Bhajan Beats",
        language: "en",
        printedPage: 2,
        clipping: "/img/media/the-morning-standard-2026-08-31.jpg", clipW: 704, clipH: 463,
      },
      {
        publication: "Punjab Kesari",
        date: "2026-09-02",
        headline: "भजन-जैमिंग सत्र में मनोज तिवारी ने की शिरकत",
        language: "hi",
        epaper:
          "https://mpaper.punjabkesari.com/m5/4194557/DELHI-MAIN-PUNJAB-KESARI/DATE-02-09-2026-PUNJAB-KESARI-DELHI-MAIN",
        clipping: "/img/media/punjab-kesari-2026-09-02.jpg", clipW: 528, clipH: 753,
      },
      {
        publication: "The Times of India",
        // The page shows one dateline, "UPDATED: SEP 30, 2026, 11:17 IST", and
        // no separate publish time; that is the date used here. The headline is
        // printed in quotation marks and keeps them.
        date: "2026-09-30",
        headline: "\u2018Bhajan jamming is collective musical experience\u2019",
        language: "en",
        url: "https://timesofindia.indiatimes.com/life-style/spotlight/bhajan-jamming-is-collective-musical-experience/articleshow/134582820.cms",
      },
    ],
  },
];

// ── Mastheads ────────────────────────────────────────────────────────────────
//
// A logo belongs to the PUBLICATION, not to a piece: a paper that writes about
// us twice has one masthead. Keyed by the exact `publication` string above.
//
// EVERY MASTHEAD SITS ON A WHITE TILE. They are irreconcilable otherwise:
// The Print, Punjab Kesari and the Morning Standard carry opaque WHITE
// backgrounds, and Dainik Jagran, Press Trust of India and The Times of India
// are transparent but drawn in near-black. A tile takes every one as it is, in their own colours,
// which is the point of showing a masthead rather than a name. It also gives the
// row one shape, since these are drawn at wildly different proportions: The
// Print is square and PTI is eight times wider than it is tall.
export const PUBLICATIONS = {
  "Press Trust of India": { logo: "/img/media/logos/press-trust-of-india.png", logoW: 1514, logoH: 188, site: "https://www.ptinews.com" },
  "The Print": { logo: "/img/media/logos/the-print.png", logoW: 190, logoH: 189, site: "https://theprint.in" },
  "The Print Hindi": { logo: "/img/media/logos/the-print-hindi.png", logoW: 204, logoH: 90, site: "https://hindi.theprint.in" },
  "Dainik Jagran": { logo: "/img/media/logos/dainik-jagran.png", logoW: 300, logoH: 163, site: "https://www.jagran.com" },
  "The Morning Standard": { logo: "/img/media/logos/the-morning-standard.png", logoW: 580, logoH: 288, site: "https://www.newindianexpress.com" },
  "Punjab Kesari": { logo: "/img/media/logos/punjab-kesari.png", logoW: 340, logoH: 98, site: "https://www.punjabkesari.in" },
  "The Times of India": { logo: "/img/media/logos/the-times-of-india.png", logoW: 296, logoH: 112, site: "https://timesofindia.indiatimes.com" },
  "Navodaya Times": { logo: "/img/media/logos/navodaya-times.png", logoW: 197, logoH: 41, site: "https://www.navodayatimes.in" },
  // Mastheads supplied by the Antara team; neither paper publishes one online.
  "Virat Vaibhav": { logo: "/img/media/logos/virat-vaibhav.png", logoW: 212, logoH: 42 },
  "Veer Arjun": { logo: "/img/media/logos/veer-arjun.png", logoW: 382, logoH: 96 },
};

/** Every publication that has written about us, in the order they appear, deduped. */
export const MEDIA_PUBLICATIONS = [
  ...new Set(MEDIA_COVERAGE.flatMap((o) => o.pieces.filter((p) => p.kind !== "release").map((p) => p.publication))),
];

/** The masthead for a publication, or an empty record when we hold nothing yet. */
export function publicationOf(name) {
  return PUBLICATIONS[name] || {};
}

/** 31 August 2026, the way the rest of the site writes a date. */
export function longDate(iso) {
  const d = new Date(`${iso}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" });
}

/** punjabkesari.in, for a link that has to say what it is. */
export function domainOf(url) {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return "";
  }
}
